export default {
  xeroProfitAndLossReport: undefined,
  xeroProfitAndLossReports: [],
};
